var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5389_1302)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5389_1302",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 176,
    height: 176
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.2 0H0V175.2H175.2V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5389_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6 175.2C135.98 175.2 175.2 135.98 175.2 87.6C175.2 39.2199 135.98 0 87.6 0C39.2199 0 0 39.2199 0 87.6C0 135.98 39.2199 175.2 87.6 175.2Z",
    fill: "#0B0F12"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4875 101.074L58.0617 88.5L45.5742 75.9258L33 88.5L45.4875 101.074Z",
    fill: "#F0B90B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.006 79.568L88.5 58.0617L67.0805 79.568L54.5062 66.9938L88.5 33L122.58 66.9938L110.006 79.568Z",
    fill: "#F0B90B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.938 88.5L131.426 75.9258L144 88.5L131.513 101.074L118.938 88.5Z",
    fill: "#F0B90B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9937 97.432L88.5 118.938L109.92 97.432L122.494 110.006L88.5 144L54.4195 110.006L66.9937 97.432Z",
    fill: "#F0B90B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.074 88.5L88.5 101.074L75.9258 88.5L88.5 75.9258L101.074 88.5Z",
    fill: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5389_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175.2,
    height: 175.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.59ecb8d70bf02277e5fc49b59c933bf6.svg";
export { ForwardRef as ReactComponent };